import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SyncScrollService {
  private scrollList: any = {};

  public add(key, elementRef): number {
    if (this.scrollList[key]) {
      return this.scrollList[key].push(elementRef) - 1;
    }
    this.scrollList[key] = [elementRef];
    return 0;
  }

  public remove(key, index) {
    if (this.scrollList[key]) {
      this.scrollList[key].splice(index, 1);
    }
  }

  public sync(key, index) {
    const scrollElems = this.scrollList[key];
    const scrollPosition = scrollElems[index].nativeElement.scrollLeft;

    for (let i = 0; i < scrollElems.length; i++) {
      if (i === index) {
        continue;
      }

      scrollElems[i].nativeElement.scrollLeft = scrollPosition;
    }
  }
}
